module.exports = __webpack_public_path__ + "media/application/images/2023/07_still-600x338-96a9e603487a490f56b40eb7f45eed3d.png";